import { expVal } from '@atlassian/jira-feature-experiments';
import { previewPanelConstants } from './previewPanelConstants.tsx';
import { useIsNotListViewRoute } from './useIsNotListViewRoute.tsx';

/**
 * The opt-in max width for preview panels opened in a list view (Issue Navigator and the other
 * list-view routes), or `undefined` elsewhere.
 */
export const useListViewPreviewPanelMaxWidth = ():
	| typeof previewPanelConstants.ISSUE_NAVIGATOR_MAX_WIDTH
	| undefined => {
	const isListViewRoute = !useIsNotListViewRoute();
	return isListViewRoute && expVal('nin_adaptive_preview_panel', 'isEnabled', false)
		? previewPanelConstants.ISSUE_NAVIGATOR_MAX_WIDTH
		: undefined;
};
